/**
 * A venue's region, worn as a coloured dot and a name (BON-538).
 *
 * The colour is the ROOT region's, so every metro under one region shares it —
 * the dot answers "whose territory" at a glance and the name answers "which
 * part of it", which is why both are here rather than a colour alone.
 */
export interface VenueRegionTagProps {
  name: string;
  color: string;
}

/** The name wraps rather than ellipsing: a truncated region is unreadable
 *  ("Massachuset…", "Upstate New …") and the roster's rows are already two
 *  lines tall for the venue name beside it, so a second line costs nothing. */
const NAME: React.CSSProperties = {
  color: 'var(--nb-muted)',
  lineHeight: 1.25,
  overflowWrap: 'break-word',
};

export function VenueRegionTag({ name, color }: VenueRegionTagProps) {
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0 }}>
      <span
        aria-hidden="true"
        style={{
          flex: '0 0 auto',
          width: 8,
          height: 8,
          borderRadius: 999,
          background: color,
        }}
      />
      <span style={NAME}>{name}</span>
    </span>
  );
}
